export default __webpack_public_path__ + "images/sweep3.2bc5d2875d0e1b0655102201ca4e2ba6.png";